import { useGameStore, useGetCurrentLanguage } from 'src/store/game'
import { useClientSideTranslation } from 'src/services/i18n'
import { useGetTotalAmount } from 'src/store/social'
import { displayMoney } from 'src/utils/displayAmount'
import { getSocialCurrencySymbol } from '../../utils/getSocialCurrencySymbol'
import { getSocialUsdRate } from '../../utils/getSocialUsdRate'

export function TotalBetAmount() {
  const totalAmount = useGetTotalAmount()
  const currentLanguage = useGetCurrentLanguage()
  const { t } = useClientSideTranslation(currentLanguage)
  const currency = useGameStore((state) => state.config?.bet?.currency)
  // undefined server rate = sweeps-table-or-1, reproducing the retired
  // getSocialDisplayMultiplier exactly. Unmounted subtree — not store-wired.
  const { rate: displayMultiplier, converted } = getSocialUsdRate(currency, undefined)

  return (
    <div className="players-stats__total-won">
      <span className="label">{t('Bets')}</span>
      <span className="value">
        {getSocialCurrencySymbol(currentLanguage, currency, converted)}
        {displayMoney((totalAmount * displayMultiplier).toString(), true)}
      </span>
    </div>
  )
}
